import { render, staticRenderFns } from "./application-confirm-info.vue?vue&type=template&id=22631749"
import script from "./application-confirm-info.vue?vue&type=script&lang=js"
export * from "./application-confirm-info.vue?vue&type=script&lang=js"
import style0 from "./application-confirm-info.vue?vue&type=style&index=0&id=22631749&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports